import React, { useContext, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { formatPimDate } from '@mummssoftware/utils/formatters';
import {
  MAINT_STATUS_PENDING,
  MAINT_ORDER_TYPE_VERBAL,
  MAINT_ORDER_TYPE_ADMIT,
  ProgressNotes as ProgressNotesWidget,
  STRING_TRUE,
} from '@mummssoftware/utils/constants';
import styled from 'styled-components';
import { Button, FormControl, Dialog } from '@material-ui/core';
import DialogContent from '@material-ui/core/DialogContent';
import { APIAlert, ReactDatePicker } from '@mummssoftware/common-ui';

import {
  GlobalContext,
  OPEN_WIDGET,
} from '@mummssoftware/global-context/GlobalContext';
import {
  MEDS_ORDER_TYPE_ADMISSION,
  MEDS_ORDER_TYPE_VERBAL,
} from '../../App/constants';
import { isClearscriptsMaintStatusResponseOK } from '../../utils/utils';
import { ApprovalConfDialog } from '../Dialog/ApprovalConfDialog';
import { AppContext } from '../../App/AppContext';
import { MedContext } from '../../App/MedContext';
import { StylesDialogTitle } from '../Dialog/WrapperDivs';

const FilterHeader = styled.div`
  font-size: 1em;
  font-weight: bold;
  color: ${(props) => props.theme.palette.text.contrastPrimaryPaper};
`;

const DatePickerContainer = styled.div`
  margin-left: 15px;
  margin-right: 15px;
  float: left;
  font-size: 10px;
  display: flex;
  align-items: baseline;
`;

const StyledButton = styled.span`
  margin-top: 15px;
  margin-bottom: 2px;
  margin-right: 15px;
  margin-left: 5px;
  text-size: 5px;
  }
`;

const DatePickerDescription = styled.div`
  font-size: 0.9rem;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  ${(props) =>
    props.needsApproval ? '' : `justify-content: flex-end; width: 100%;`}
  @media screen and (max-device-width: 585px) {
    float: left;
  }
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    flex-basis: 100%;
    width: 100%;
    max-width: 100%;
    justify-content: flex-start;
    float: none;
    & > span {
      margin-top: 0;
      margin-bottom: 0;
      margin-right: 0;
      margin-left: 0;
    }
    & button {
      width: 100%;
      box-sizing: border-box;
    }
  }
`;

const hiddenContainer = styled.div`
  width: 30px;
  height: 15px;
  display: hidden;
`;

const FilterContent = styled.div`
  display: flex;
  justify-content: end;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: ${(props) =>
    props.isInMedOrdersBinList ? '' : 'space-between'};
  padding: 2px;
`;

const StyledDialog = styled(Dialog)`
  color: ${(props) => props.theme.palette.text.secondary};
`;
// todo common-ui

const FilterContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledDialogMsgContainer = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-size: ${(props) => props.theme.typography.body2.fontSize};
  fontweight: ${(props) => props.theme.typography.body2.fontWeight};
  lineheight: ${(props) => props.theme.typography.body2.lineHeight};
`;

const StyledOrderedList = styled.ol`
  font-size: ${(props) => props.theme.typography.body2.fontSize};
  fontweight: ${(props) => props.theme.typography.body2.fontWeight};
  lineheight: ${(props) => props.theme.typography.body2.lineHeight};
`;

const StyledDialogButtonContainer = styled.div`
  display: flex;
  justify-content: center;

  & Button {
    margin-left: 5px;
    margin-right: 5px;
  }
`;

const FilterBarContent = ({
  handleExternalLink,
  messages,
  cancelApprovalProcess,
  showCheckmarks,
  areMedsApproved,
  handleApproveClick,
  handleApproveMeds,
}) => {
  const {
    isDoctor,
    isNurse,
    isMobile,
    userId,
    personNumber,
    patient,
    updateMaintPayload,
    clearScriptsLogin,
    handleApproveMedsBtnClick,
    isInMedOrdersBinList,
    setMedsOrderType,
    updateMaintStatusV2,
    pullAndUpdateMedications,
    disableUpdateMedsBtn,
  } = useContext(AppContext);
  const globalContext = useContext(GlobalContext);

  const { medications } = useContext(MedContext);

  const needsApproval = medications.some(
    (medication) =>
      (!medication.reconcileddate || medication.reconcileddate === '') &&
      (!medication.medatadmit || medication.medatadmit !== STRING_TRUE),
  );

  const [recordedDate, setRecordedDate] = useState(null);
  // this is set to false if there is a date in the picker.  If user isDoctor, they they wont
  // see the picker, so set this to false by default.
  const [disableApprove, setDisableApprove] = useState(!isDoctor);
  const [showApprovalDialog, setShowApprovalDialog] = useState(false);

  const handleApprovalDialogClose = () => setShowApprovalDialog(false);

  const [showMaintUpdateErrorMsg, setShowMaintUpdateErrorMsg] = useState(false);
  const [showMedComfDialog, setShowMedComfDialog] = useState(false);
  const [showMedsAtAdmitText, setShowMedsAtAdmitText] = useState(false);
  const [showVerbalOrderText, setShowVerbalOrderText] = useState(false);

  const handleOpenMedsComfDialogForAdmit = () => {
    setShowVerbalOrderText(false);

    setShowMedsAtAdmitText(true);
    setShowMedComfDialog(true);
  };

  const updateMaintStatusCallback = (res, payload) => {
    if (isClearscriptsMaintStatusResponseOK(res)) {
      handleExternalLink().then(() => {
        setShowMedComfDialog(false);
        updateMaintPayload(payload);
      });
    } else {
      setShowMaintUpdateErrorMsg(true);
    }
  };
  const handleApproveConfirmClick = (date, isDoc) => {
    handleApproveClick(date, isDoc);
    handleApproveMeds();
    setShowApprovalDialog(false);
  };

  const handleOpemMedsComfDialogForVerbal = () => {
    setShowVerbalOrderText(true);
    setShowMedComfDialog(true);

    // if you are a site using med orders, go ahead and load the  O/N screen when they
    // click the button.
    const isNarrowPhoneLayout =
      typeof window !== 'undefined' &&
      window.matchMedia('(max-width: 600px)').matches;

    if (isInMedOrdersBinList && !isNarrowPhoneLayout) {
      const pnWidget = {
        componentName: ProgressNotesWidget,
      };

      // call to open O/N widget:
      globalContext.dispatch({
        type: OPEN_WIDGET,
        payload: pnWidget,
      });
    }
  };

  const getApprovalWorkflowBtnText = () => {
    if (isDoctor) {
      return <FormattedMessage {...messages.medsApprovedPhyBTN} />;
    }
    return isMobile ? (
      <FormattedMessage {...messages.recordHardCopyMobileMSG} />
    ) : (
      <FormattedMessage {...messages.recordHardCopyMSG} />
    );
  };

  const handleAdmitDialogContinueBtn = () => {
    // maintstatus/v2 path
    if (isInMedOrdersBinList) {
      const payload = {
        status: MAINT_STATUS_PENDING,
        ordertype: MAINT_ORDER_TYPE_ADMIT,
        conversationtypename: '',
        orderdate: formatPimDate(new Date()),
        // ordering physician info
        orderingphysicianid: '',
        orderingphysicianpersonnumber: '',
        // currentuser info
        currentuserid: `${userId}`,
        currentuserpersonnumber: personNumber,
        currentuserclearscriptslogin: clearScriptsLogin,
        // patient info
        patientnumber: patient.patientNumber,
        patientid: `${patient.id}`,
        patientprogressnoteid: '',
        approvalid: '',
      };

      updateMaintStatusV2(payload).then((res) =>
        updateMaintStatusCallback(res, payload),
      );
    }
    // original mainstatus workflow.  To be depricated.
    // does not call the maint status endpoint with a pending status
    else {
      setMedsOrderType(MEDS_ORDER_TYPE_ADMISSION);
      handleExternalLink().then(() => {
        setShowMedComfDialog(false);
      });
    }
  };

  const handleVerbalDialogContinueBtn = () => {
    // maintstatus/v2 path
    if (!isInMedOrdersBinList) {
      setMedsOrderType(MEDS_ORDER_TYPE_VERBAL);
      handleExternalLink().then(() => {
        setShowMedComfDialog(false);
      });
    }
  };

  const handlePullMedsBtnClick = () => {
    pullAndUpdateMedications();
  };

  const handleEPerscribeBtnClick = () => {
    if (isInMedOrdersBinList) {
      const payload = {
        status: MAINT_STATUS_PENDING,
        conversationtypename: '',
        ordertype: MAINT_ORDER_TYPE_VERBAL,
        orderdate: formatPimDate(new Date()),
        // ordering physician info
        orderingphysicianid: `${userId}`,
        orderingphysicianpersonnumber: personNumber,
        // currentuser info
        currentuserid: `${userId}`,
        currentuserpersonnumber: personNumber,
        currentuserclearscriptslogin: clearScriptsLogin,
        // patient info
        patientnumber: patient.patientNumber,
        patientid: `${patient.id}`,
        patientprogressnoteid: '',
        approvalid: '',
        iseprescribing: 'true',
      };

      updateMaintStatusV2(payload).then((res) =>
        updateMaintStatusCallback(res, payload),
      );
    }
    // original mainstatus workflow.  To be depricated.
    // does not call the maint status endpoint with a pending status
    else {
      setMedsOrderType(MEDS_ORDER_TYPE_VERBAL);
      handleExternalLink().then(() => {
        setShowMedComfDialog(false);
      });
    }
  };

  const handleMaintainBtnClick = () => {
    if (isInMedOrdersBinList) {
      const payload = {
        status: MAINT_STATUS_PENDING,
        ordertype: MAINT_ORDER_TYPE_VERBAL,
        conversationtypename: '',
        orderdate: formatPimDate(new Date()),
        // ordering physician info
        orderingphysicianid: '',
        orderingphysicianpersonnumber: '',
        // currentuser info
        currentuserid: `${userId}`,
        currentuserpersonnumber: personNumber,
        currentuserclearscriptslogin: clearScriptsLogin,
        // patient info
        patientnumber: patient.patientNumber,
        patientid: `${patient.id}`,
        patientprogressnoteid: '',
        approvalid: '',
      };

      updateMaintStatusV2(payload).then((res) =>
        updateMaintStatusCallback(res, payload),
      );
    }

    // original mainstatus workflow.  To be depricated.
    // does not call the maint status endpoint with a pending status
    else {
      setMedsOrderType(MEDS_ORDER_TYPE_ADMISSION);
      handleExternalLink().then(() => {
        setShowMedComfDialog(false);
      });
    }
  };

  const handleCloseMedComfDialog = () => {
    setShowMedsAtAdmitText(false);
    setShowVerbalOrderText(false);
    setShowMedComfDialog(false);
  };

  const getMedsConfDialogText = () => {
    if (showMedComfDialog && showMedsAtAdmitText) {
      return (
        <>
          <FormattedMessage {...messages.maintainOptionsTxt} />
          <StyledOrderedList>
            <li>
              <FormattedMessage {...messages.maintain_opt1} />
            </li>
            <li>
              <FormattedMessage {...messages.maintain_opt2} />
            </li>
            <li>
              <FormattedMessage {...messages.maintain_opt3} />
            </li>
          </StyledOrderedList>
        </>
      );
    }
    // if the site is not in the med order bin list, show them the old confirmation message
    else if (!isInMedOrdersBinList && showMedComfDialog && showVerbalOrderText)
      return <FormattedMessage {...messages.medsVerbalOrderMSG} />;
    else if (isInMedOrdersBinList && showMedComfDialog && showVerbalOrderText)
      return <FormattedMessage {...messages.medsOrdersAndNotesMovedNotice} />;
    return '';
  };

  // TODO: Refactor out once med orders work is rolled out to all users.
  const doLegecyShowMedsVerbalText =
    !isInMedOrdersBinList && !showMedsAtAdmitText && showVerbalOrderText;

  const showOKButtonOnConfDialog =
    isInMedOrdersBinList && showMedComfDialog && showVerbalOrderText;
  const medsConfDialog = () => (
    <StyledDialog
      onClose={handleCloseMedComfDialog}
      open={showMedComfDialog}
      BackdropProps={{ style: { backgroundColor: 'transparent' } }}
    >
      <StylesDialogTitle id="meds-verbal-orders-dialog" disableTypography>
        <FormattedMessage {...messages.medsConfDialogTitle} />
      </StylesDialogTitle>
      <DialogContent>
        <StyledDialogMsgContainer>
          {getMedsConfDialogText()}
        </StyledDialogMsgContainer>
        <StyledDialogButtonContainer>
          {showMedsAtAdmitText && !showVerbalOrderText && (
            <Button
              aria-controls="simple-menu"
              size="small"
              color="primary"
              variant="outlined"
              onClick={handleAdmitDialogContinueBtn}
            >
              <FormattedMessage {...messages.maintainToRcopiaBtn} />
            </Button>
          )}
          {doLegecyShowMedsVerbalText && (
            <Button
              aria-controls="simple-menu"
              size="small"
              color="primary"
              variant="outlined"
              onClick={handleVerbalDialogContinueBtn}
            >
              <FormattedMessage {...messages.continueBTN} />
            </Button>
          )}
          <Button
            size="small"
            color="primary"
            variant="outlined"
            onClick={handleCloseMedComfDialog}
          >
            {showOKButtonOnConfDialog ? (
              <FormattedMessage {...messages.okBTN} />
            ) : (
              <FormattedMessage {...messages.cancelBTN} />
            )}
          </Button>
        </StyledDialogButtonContainer>
      </DialogContent>
    </StyledDialog>
  );

  // TODO: refactor out the approval workflow once all sites are live with med orders.
  const showApprovalWorkflowStartButton =
    !isInMedOrdersBinList && needsApproval && !showCheckmarks;

  const showApprovalWorkflowUI =
    !isInMedOrdersBinList && needsApproval && showCheckmarks;

  const showApprovalWorkflowConfDialog =
    !isInMedOrdersBinList && showApprovalDialog;

  // while we still have the approval workflow, do not show the rcopia buttons while in
  // approval workflow, aka if showCheckmarks is true.
  const showNurseRcopiaButtons = !showCheckmarks && !isDoctor && isNurse;

  const showDoctorRcopiaButtons = !showCheckmarks && isDoctor;
  // These are non nurse and non doctors that sites allow access for changing allergies
  // and checking med records.
  const showMedRecordsRcopiaButton = !showCheckmarks && !isNurse && !isDoctor;

  const showRcopiaBtns = clearScriptsLogin && clearScriptsLogin !== '';

  const updateMedsBtnConfig = (() =>
    disableUpdateMedsBtn
      ? messages.updateMedsInProgress
      : messages.updateMeds)();

  return (
    <FilterContent
      id="filter-top-bar"
      isInMedOrdersBinList={isInMedOrdersBinList}
    >
      {showMaintUpdateErrorMsg ? (
        <APIAlert
          errorInfo={{
            text: <FormattedMessage {...messages.medOrderError} />,
            severity: 'error',
          }}
          handleClose={() => setShowMaintUpdateErrorMsg(false)}
          persistentError
        />
      ) : null}
      {/* APPROVAL WORKFLOW */}
      {showApprovalWorkflowStartButton ? (
        <ButtonContainer needsApproval={needsApproval}>
          <StyledButton>
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={handleApproveMedsBtnClick}
            >
              <FilterHeader>{getApprovalWorkflowBtnText()}</FilterHeader>
            </Button>
          </StyledButton>
        </ButtonContainer>
      ) : null}
      {showApprovalWorkflowUI ? (
        <FilterContainer>
          <div>
            {/* SUBMIT BUTTON */}
            <StyledButton>
              <Button
                size="small"
                color="primary"
                variant="contained"
                disabled={disableApprove || !areMedsApproved}
                onClick={() => setShowApprovalDialog(true)}
              >
                <FilterHeader>
                  <FormattedMessage {...messages.Submit} />
                </FilterHeader>
              </Button>
            </StyledButton>
          </div>
          {/* NURSE HARD COPY SIG DATE */}
          {!isDoctor && (
            <DatePickerContainer>
              <FormControl>
                <DatePickerDescription>
                  <FilterHeader>
                    <FormattedMessage {...messages.hardCopySigDateMSG} />
                  </FilterHeader>
                </DatePickerDescription>
                <ReactDatePicker
                  selectedDate={recordedDate}
                  onChange={(date) => {
                    setRecordedDate(date);
                    setDisableApprove(false);
                  }}
                  maximumDate={new Date()}
                />
              </FormControl>
            </DatePickerContainer>
          )}
          {/* CANCEL BUTTON */}
          {showCheckmarks && (
            <div>
              <StyledButton>
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={cancelApprovalProcess}
                >
                  <FilterHeader>
                    <FormattedMessage {...messages.Cancel} />
                  </FilterHeader>
                </Button>
              </StyledButton>
            </div>
          )}
          {/* maintain space for the approval buttons even when there is no approvals needed */}
          {!showCheckmarks && !needsApproval && (
            <hiddenContainer> </hiddenContainer>
          )}
        </FilterContainer>
      ) : null}
      {showApprovalWorkflowConfDialog ? (
        <ApprovalConfDialog
          showApprovalDialog={showApprovalDialog}
          setShowApprovalDialog={setShowApprovalDialog}
          handleApprovalDialogClose={handleApprovalDialogClose}
          messages={messages}
          isDoctor={isDoctor}
          handleApproveConfirmClick={handleApproveConfirmClick}
          recordedDate={recordedDate}
        />
      ) : null}

      {showRcopiaBtns && (
        <ButtonContainer needsApproval={needsApproval}>
          {/* maintain button */}
          <StyledButton onClick={handlePullMedsBtnClick}>
            <Button
              size="small"
              variant="contained"
              color="primary"
              disabled={disableUpdateMedsBtn}
            >
              <FormattedMessage {...updateMedsBtnConfig} />
            </Button>
          </StyledButton>
          {showDoctorRcopiaButtons && (
            <StyledButton onClick={handleEPerscribeBtnClick}>
              <Button size="small" variant="contained" color="primary">
                <FormattedMessage {...messages.ePerscribe} />
              </Button>
            </StyledButton>
          )}
          {showNurseRcopiaButtons && (
            <>
              <StyledButton onClick={handleOpenMedsComfDialogForAdmit}>
                <Button size="small" variant="contained" color="primary">
                  <FormattedMessage {...messages.maintainBTN} />
                </Button>
              </StyledButton>
              <StyledButton onClick={handleOpemMedsComfDialogForVerbal}>
                <Button size="small" variant="contained" color="primary">
                  <FormattedMessage {...messages.medsVerbalOrderBTN} />
                </Button>
              </StyledButton>
            </>
          )}
          {showMedRecordsRcopiaButton && (
            <StyledButton onClick={handleMaintainBtnClick}>
              <Button size="small" variant="contained" color="primary">
                <FormattedMessage {...messages.maintainBTN} />
              </Button>
            </StyledButton>
          )}
        </ButtonContainer>
      )}

      {showMedComfDialog && medsConfDialog()}
    </FilterContent>
  );
};

export default React.memo(FilterBarContent);
